import { News } from '../../../types/News';
import { FiChevronRightIcon } from '../../Icon';
import { Category } from '../../Tag/Category';
import { Time } from '../../Tag/Time';

import styles from './NewsCard.module.scss';

import type { FC } from 'react';

export type Props = {
  newsList: News[];
};

const NewsList: FC<Props> = ({ newsList }) => (
  <>
    {newsList.map((news) => (
      <a className={styles['wrap-article']} key={news.id} href={news.link}>
        <div className={styles['box-article']}>
          <span className={styles['right-title']}>{news.title}</span>
          <div className={styles['right-above']}>
            {news.isNewArrivals ? (
              <Category size="M" color="primary" text="新着" />
            ) : (
              ''
            )}

            <Time size="M" text={news.publishedDate} />
          </div>
        </div>
        <FiChevronRightIcon size={18} />
      </a>
    ))}
  </>
);

export const NewsCard: FC<Props> = ({ newsList }) => (
  <div>
    <NewsList newsList={newsList} />
  </div>
);
